var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b2d779b79881fe73ba25297ac531384efc651a32"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["digital-spiders-website@digital-spiders"]={id:"b2d779b79881fe73ba25297ac531384efc651a32"};
      